'use strict';

var React = require('react');
var Card = require('../../../node_modules/@material-ui/core/esm/Card/Card.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  wrapper: {
    padding: 40,
    textAlign: 'justify'
  }
};

function SplitPaneCard(_ref) {
  var classes = _ref.classes,
      children = _ref.children;
  return React__default["default"].createElement(Card["default"], null, React__default["default"].createElement("div", {
    className: classes.wrapper
  }, children));
}

var SplitPaneCard$1 = withStyles(styles)(SplitPaneCard);

module.exports = SplitPaneCard$1;
